var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isParent)?_c('eval-disbursement-parent-list'):(_vm.isParish)?_c('eval-disbursement-child-list'):_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }